import React, { useMemo, useState } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";

const sections = [
  {
    title: "North Region",
    items: [
      {
        title: "Najafgarh, Delhi - New Delhi",
        image: "/assets/images/location-img1.webp",
        mapUrl: "https://goo.gl/maps/evRm9HFm6ZEca1UE7"
      },
      {
        title: "Sohna Road, Gurgaon - Haryana",
        image: "/assets/images/location-img2.webp",
        mapUrl: ""
      },
      {
        title: "G.B. Nagar, Noida - Uttar Pardesh",
        image: "/assets/images/location-img3.webp",
        mapUrl: ""
      },
      {
        title: "Nadarganj, Lucknow - Uttar Pardesh",
        image: "/assets/images/location-img4.webp",
        mapUrl: ""
      },
      {
        title: "Jhamuwas, Tauru-Bilaspur - Haryana",
        image: "/assets/images/location-img5.webp",
        mapUrl: ""
      },
      {
        title: "Bhondsi,  Gurgaon - Haryana",
        image: "/assets/images/location-img6.webp",
        mapUrl: "https://g.page/awl-india-pvt-ltd---bhondsi?gm"
      },
      {
        title: "Dera Bassi, Zirakpur - Punjab",
        image: "/assets/images/location-img7.webp",
        mapUrl: ""
      },

      {
        title: "Mohali, Zirakpur - Punjab",
        image: "/assets/images/location-img8.webp",
        mapUrl: ""
      },

      {
        title: "Kot Kalan, Jalandhar - Punjab",
        image: "/assets/images/location-img9.webp",
        mapUrl: ""
      },

      {
        title: "Lakhanpur, Bilaspur - Himachal",
        image: "/assets/images/location-img10.webp",
        mapUrl: ""
      },

      {
        title: "Mahapura, Jaipur - Rajasthanl",
        image: "/assets/images/location-img11.webp",
        mapUrl: ""
      },

      {
        title: "Transport Nagar, Dehradun - UK",
        image: "/assets/images/location-img12.webp",
        mapUrl: ""
      },
    ],
  },
  {
    title: "East-Region",
    items: [
      {
        title: "Maheshtala, Kolkata - West Bengal",
        image: "/assets/images/location-img13.webp",
        mapUrl: "https://g.page/awl-india-pvt-ltd-kolkata?gm"
      },
      {
        title: "Lokhra, Guwahati - Assam",
        image: "/assets/images/location-img14.webp",
        mapUrl: "https://goo.gl/maps/5zCEUSTKyf1KKWc76"
      },
      {
        title: "Kantabada, Bhubaneswar - Odisha",
        image: "/assets/images/location-img15.webp",
      },
      {
        title: "Matigara, Siliguri - West Bengal",
        image: "/assets/images/location-img16.webp",
      },
    ],
  },
  {
    title: "West-Region",
    items: [
      {
        title: "Changodar City, Ahmedabad - Gujarat",
        image: "/assets/images/location-img17.webp",
        mapUrl: "https://g.page/awl-india-pvt-ltd---ahmedabad?gm"
      },
      {
        title: "Green Space, Bhiwandi - Maharashtra",
        image: "/assets/images/location-img18.webp",
        mapUrl: "https://goo.gl/maps/hdzYr2T7bVBW7A5t9"
      },
      {
        title: "Khalapur, Mumbai - Maharashtra",
        image: "/assets/images/location-img19.webp",
        mapUrl: "https://g.page/awl-india-pvt-ltd---mumbai?gm"
      },
      {
        title: "Bardez, Goa - Goa",
        image: "/assets/images/location-img20.webp",
        mapUrl: "https://goo.gl/maps/NQMYGRdMUbCag3Vp8"

      },

      {
        title: "Umbrae Navalakh, Pune - Maharashtra",
        image: "/assets/images/location-img21.webp",
        mapUrl: "https://goo.gl/maps/rEFQm7FSaG6VwD7j6"
      },

      {
        title: "Kurla Road, Andheri - Maharashtra",
        image: "/assets/images/location-img22.webp",
      },

      {
        title: "Lasudia Mori, Indore - Madhya Pradesh",
        image: "/assets/images/location-img23.webp",
      },
    ],
  },
  {
    title: "South-Region",
    items: [
      {
        title: "Maheshtala, Kolkata - West Bengal",
        image: "/assets/images/location-img24.webp",
      },
      {
        title: "Hyderabad, Tumkunta - Telangana",
        image: "/assets/images/location-img25.webp",
        mapUrl: "https://g.page/awl-india-pvt-ltd-hyderabad?gm"
      },
      {
        title: "Polivakkam, Chennai - Tamil Nadu",
        image: "/assets/images/location-img26.webp",
        mapUrl: "https://g.page/awl-india-pvt-ltd---chennai?gm"
      },
      {
        title: "Heggadevapura, Bangalore - Karnataka",
        image: "/assets/images/location-img27.webp",
        mapUrl: "https://goo.gl/maps/XCJoAbZs1c6Zawvy7"
      },

    ],
  },
];


export default function MultipleLocations() {
  const [search, setSearch] = useState("");
  const [sortBy, setSortBy] = useState("name");
  const filteredSections = useMemo(() => {
    return sections
      .map((section) => {
        let items = section.items.filter((item) =>
          item.title.toLowerCase().includes(search.toLowerCase())
        );

        if (sortBy === "name") {
          items = [...items].sort((a, b) => a.title.localeCompare(b.title));
        }

        return { ...section, items };
      })
      .filter((section) => section.items.length > 0);
  }, [search, sortBy]);


  return (
    <>
      <section className="destination-section">
        <div className="container">
          <div className="top-filter">
            <div className="location-filter-box">
              <div className="sort-box">
                <span className="sort-title">Sort by:</span>
                <div className="sort-wrapper">
                  <label className="custom-radio">
                    <input type="radio" name="sortBy" checked={sortBy === "name"} onChange={() => setSortBy("name")} />
                    <span className="radio-circle"></span>
                    <span className="radio-text">Names A-Z</span>
                  </label>
                  <label className="custom-radio">
                    <input type="radio" name="sortBy" checked={sortBy === "closest"} onChange={() => setSortBy("closest")} />
                    <span className="radio-circle"></span>
                    <span className="radio-text">Closest To Me</span>
                  </label>
                </div>
              </div>
              <div className="search-box">
                <input type="text" placeholder="Search location here" className="form-control" value={search} onChange={(e) => setSearch(e.target.value)} />
                <span className="search-icon"><Icons name="search" /></span>
              </div>
            </div>
          </div>
          {filteredSections.map((section, index) => (
            <div className="region-block" key={index}>
              <div className="region-title">{section.title}</div>
              <div className="row g-4">
                {section.items.map((item, i) => (
                  <div className="col-12 col-sm-6 col-lg-4" key={i}>
                    <div className="destination-card">
                      <img src={item.image} alt={item.title} className="img-responsive" />
                      <div className="card-content">
                        <div className="title">{item.title}</div>
                        {/* <Link to="/" className="map-loc">
                          Open in Map
                          <Icons name="Longarrow_right" />
                          <img src="/assets/images/arrow-img.webp" alt="Arrow" className="img-responsive" />
                        </Link> */}
                        <Link
                          to={item.mapUrl || "#"}
                          target={item.mapUrl ? "_blank" : undefined}
                          rel={item.mapUrl ? "noopener noreferrer" : undefined}
                          className={`map-loc ${!item.mapUrl ? "disabled" : ""}`}
                          onClick={(e) => {
                            if (!item.mapUrl) {
                              e.preventDefault();
                            }
                          }}
                        >
                          Open in Map
                          <Icons name="Longarrow_right" />
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}


